import MainMenu from "./MainMenu";
import { Container } from '@mui/system';
import Grid from '@mui/material/Grid';
// import { useState } from 'react';
import {Brightness2, LightMode} from '@mui/icons-material';

function Header({value, theme}) {

  return (
      <Container>
        <header>
          <div className="container">
          <Grid container alignItems="center">
            <Grid item xs>
              <MainMenu />
            </Grid>
            <Grid>
              <div className="btn">
              {
               (localStorage.getItem('theme')) 
                ? <LightMode onClick={value}/>
                : <Brightness2 onClick={value}/>
              }
              </div>
            </Grid>
          </Grid>
          </div>
        </header>
      </Container>
    );
  }
  
  export default Header;